import type { NotificationEventType } from './event-notification.model';

/**
 * Email digest delivery cadence when the user has opted into email
 * (R10 Phase 2 — `realtime` / `daily` / `weekly`).
 */
export type EmailDigestCadence = 'realtime' | 'daily' | 'weekly';

/**
 * Per-event-type channel toggles.
 *
 * Email defaults off (opt-in only); in-app defaults on for the persona catalog.
 */
export type NotificationEventChannelPreference = {
  email: boolean;
  inApp: boolean;
};

/**
 * Current-user notification preferences singleton
 * (`GET` / `PATCH` `/api/v1/notification_preferences`).
 */
export type NotificationPreferences = {
  digestCadence: EmailDigestCadence;
  emailDigestEnabled: boolean;
  eventTypes: Partial<
    Record<NotificationEventType, NotificationEventChannelPreference>
  >;
  id: number;
  inAppEnabled: boolean;
};

/** Event types exposed on the preferences UI (Effort M subset of R10). */
export const PREFERENCE_EVENT_TYPES = [
  'capability_suggestion_approved',
  'capability_suggestion_rejected',
  'factory_published',
  'factory_rejected',
  'profile_viewed',
  'project_factory_added',
] as const satisfies readonly NotificationEventType[];

export type PreferenceEventType = (typeof PREFERENCE_EVENT_TYPES)[number];
